module.exports = __webpack_public_path__ + "static/media/lnkd.bd97b323.svg";